import axios from "axios";
import apiUrl from "../constants/apiUrl";

const api = axios.create({
  baseURL: apiUrl, // e.g. http://localhost:8000/sigmas
});

function getAccess() {
  return localStorage.getItem("access_token");
}
function getRefresh() {
  return localStorage.getItem("refresh_token");
}
function setTokens(access?: string, refresh?: string) {
  if (access) localStorage.setItem("access_token", access);
  if (refresh) localStorage.setItem("refresh_token", refresh);
}

api.interceptors.request.use((config) => {
  const token = getAccess();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401 once
let isRefreshing = false;
let queue: ((tkn: string | null) => void)[] = [];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error?.response?.status === 401 && !original._retry) {
      if (isRefreshing) {
        // queue requests while a refresh is in-flight
        return new Promise((resolve) => {
          queue.push((newToken) => {
            if (newToken) {
              original.headers.Authorization = `Bearer ${newToken}`;
              resolve(api(original));
            } else {
              resolve(Promise.reject(error));
            }
          });
        });
      }

      original._retry = true;
      isRefreshing = true;
      try {
        const refresh = getRefresh();
        if (!refresh) throw new Error("No refresh token");
        const resp = await axios.post(`${apiUrl}/auth/api/token/refresh/`, {
          refresh,
        });
        const newAccess: string = resp.data.access;
        setTokens(newAccess, resp.data.refresh); // rotatable refresh if enabled
        // flush queue
        queue.forEach((cb) => cb(newAccess));
        queue = [];
        original.headers.Authorization = `Bearer ${newAccess}`;
        return api(original);
      } catch (e) {
        queue.forEach((cb) => cb(null));
        queue = [];
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        // optional: redirect to login
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
